<template>
  <v-container max-width="100%" :style="embedded ? 'margin-top: 0; padding: 0;' : 'margin-top: 2%'">
    <merus-data-table
      :headers="headers"
      :items="statusTickets"
      :loading="loading"
      :loading-text="$t('ticketStatus.loading')"
      @update:displayedItems="displayedItemsForExport = $event"
    

 cod-tabela="STATUSTICKETS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <cadastro-toolbar
          :title="embedded ? '' : $t('ticketStatus.title')"
          :token="token"
          :items="displayedItemsForExport !== null ? displayedItemsForExport : statusTickets"
          :csv-title="$t('ticketStatus.title')"
          :csv-headers="headers"
          :pdf-title="$t('ticketStatus.title')"
          :pdf-headers="headers"
          :pdf-filename="$t('ticketStatus.title')"
          hide-search
        >
          <template v-slot:add v-if="canInsert">
            <v-btn color="primary" dark small class="mb-2" @click="dialog = true" fab>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <v-card>
                <v-card-title class="justify-center pa-6">
                  <v-icon left color="primary" class="mr-3">{{ formIcon }}</v-icon>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-form ref="form" v-model="formValidado">
                    <v-row>
                      <v-col cols="12">
                        <v-card class="pa-4 mb-4" outlined>
                          <v-card-title class="text-h6 pa-0 mb-3">
                            {{ $t('ticketStatus.name') }}
                          </v-card-title>
                          <v-divider class="mb-3"></v-divider>
                          <v-text-field
                            v-model="editedItem.status_ticket"
                            :label="$t('ticketStatus.name')"
                            :rules="[(v) => !!v || $t('rules.messageName')]"
                            dense
                            outlined
                            hide-details
                          />
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card class="pa-4 mb-4" outlined>
                          <v-card-title class="text-h6 pa-0 mb-3">
                            {{ $t('ticketStatus.screen') }}
                          </v-card-title>
                          <v-divider class="mb-3"></v-divider>
                          <v-select
                            v-model="editedItem.screen"
                            :items="screenItems"
                            item-text="text"
                            item-value="value"
                            :label="$t('ticketStatus.screen')"
                            dense
                            outlined
                            hide-details
                          />
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card class="pa-4 mb-4" outlined>
                          <v-card-title class="text-h6 pa-0 mb-3">
                            {{ $t('ticketStatus.autoConclude') }}
                          </v-card-title>
                          <v-divider class="mb-3"></v-divider>
                          <v-select
                            v-model="editedItem.ids_tipos_conclusao_auto"
                            :items="tiposTicket"
                            item-text="nome_tipo_ticket"
                            item-value="id_tipo_ticket"
                            :label="$t('ticketStatus.autoConcludeTypes')"
                            :hint="$t('ticketStatus.autoConcludeHint')"
                            persistent-hint
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            clearable
                            dense
                            outlined
                          />
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="primary" dark @click="save" :loading="loadingStatus">
                    <v-icon left>mdi-content-save</v-icon>{{ $t('button.save') }}
                  </v-btn>
                  <v-btn color="primary" dark @click="close" :loading="loadingStatus">
                    <v-icon left>mdi-close</v-icon>{{ $t('button.close') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </cadastro-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
        <v-icon small color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
        <v-icon
          small
          class="mr-2"
          color="primary"
          @click="moveUp(item)"
          :disabled="loadingReorder || !canEdit || isFirstItem(item)"
        >mdi-arrow-up-bold</v-icon>
        <v-icon
          small
          color="primary"
          @click="moveDown(item)"
          :disabled="loadingReorder || !canEdit || isLastItem(item)"
        >mdi-arrow-down-bold</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import EventBus from "@/utils/eventBus";
import MerusDataTable from "../Tables/MerusDataTable.vue";
import CadastroToolbar from "../Toolbars/CadastroToolbar.vue";
import apiController from "@/utils/apiController";

export default {
  name: "CRUDStatusTickets",
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  props: {
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    headers: [],
    displayedItemsForExport: null,
    user: null,
    token: null,
    dialog: false,
    statusTickets: [],
    tiposTicket: [],
    loading: false,
    formValidado: false,
    editedIndex: -1,
    editedItem: {
      id_status_ticket: null,
      status_ticket: "",
      ordem: null,
      screen: null,
      ids_tipos_conclusao_auto: [],
    },
    defaultItem: {
      id_status_ticket: null,
      status_ticket: "",
      ordem: null,
      screen: null,
      ids_tipos_conclusao_auto: [],
    },
    loadingStatus: false,
    loadingReorder: false,
    operacao: 0,
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
  }),
  computed: {

    formTitle() {
      return this.editedIndex === -1 ? this.$t("ticketStatus.new") : this.$t("ticketStatus.edit");
    },
    formIcon() {
      return this.editedIndex === -1 ? "mdi-plus-circle" : "mdi-pencil";
    },
    screenItems() {
      return [
        { text: this.$t("ticketStatus.screenAll"), value: null },
        { text: this.$t("ticketStatus.screenColaborador"), value: "colaborador" },
        { text: this.$t("ticketStatus.screenDispatcher"), value: "dispatcher" }];
    },
  },
  watch: {
    "$i18n.locale"() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  methods: {

    getScreenLabel(screen) {
      if (!screen) return this.$t("ticketStatus.screenAll");
      if (screen === "colaborador") return this.$t("ticketStatus.screenColaborador");
      if (screen === "dispatcher") return this.$t("ticketStatus.screenDispatcher");
      return screen;
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatestatusticket");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertstatusticket");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletestatusticket");
            this.initialize();
          },
        });
      }
    },
    initialize() {
      this.populaTiposTicket();
      this.populaStatus();
    },
    populaTiposTicket() {
      apiController.request(apiController.endpoints.getallTipostickets, {
        onSuccess: (response) => {
          this.tiposTicket = response.data || [];
        },
      });
    },
    populaStatus() {
      this.loading = true;
      apiController.request(apiController.endpoints.getallStatus, {
        onSuccess: (response) => {
          const items = (response.data || []).map((item) => ({
            ...item,
            screen_extenso: this.getScreenLabel(item.screen),
            ids_tipos_conclusao_auto: item.ids_tipos_conclusao_auto
              ? String(item.ids_tipos_conclusao_auto).split(",").map(Number)
              : [],
          }));
          this.statusTickets = this.sortByOrder(items);
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    updateTable(response) {
      if (response.data.erro) {
        if (this.operacao === 0) {
          EventBus.$emit("show-alert", {
            mensagem: this.$t("ticketStatus.errors.errorAdd") + ": " + response.data.mensagem,
            tipo: "error",
          });
        } else {
          EventBus.$emit("show-alert", {
            mensagem: this.$t("ticketStatus.errors.errorUpdate") + ": " + response.data.mensagem,
            tipo: "error",
          });
        }
        return;
      }
      if (this.operacao === 0) {
        EventBus.$emit("show-alert", { mensagem: this.$t("ticketStatus.successes.successAdd"), tipo: "success" });
      } else {
        EventBus.$emit("show-alert", { mensagem: this.$t("ticketStatus.successes.successUpdate"), tipo: "success" });
      }
      this.close();
      this.initialize();
    },
    save() {
      if (!this.formValidado) {
        EventBus.$emit("show-alert", { mensagem: this.$t("ticketStatus.formErrorsSave"), tipo: "warning" });
        return;
      }

      if (!this.editedItem.status_ticket) {
        EventBus.$emit("show-alert", { mensagem: this.$t("ticketStatus.nameRequired"), tipo: "warning" });
        return;
      }
      this.loadingStatus = true;
      if (this.editedIndex === -1) {
        this.operacao = 0;
        const nextOrder = this.statusTickets.length > 0
          ? Math.max(...this.statusTickets.map((s) => Number(s.ordem) || 0)) + 1
          : 1;
        apiController.request(apiController.endpoints.insertStatusticket, {
            data: {
              status_ticket: this.editedItem.status_ticket,
              ordem: nextOrder,
              screen: this.editedItem.screen || null,
              ids_tipos_conclusao_auto: this.editedItem.ids_tipos_conclusao_auto || [],
            },
            onSuccess: (response) => {
              this.updateTable(response);
              this.loadingStatus = false;
            },
            onError: () => {
              this.loadingStatus = false;
            },
          });
      } else {
        this.operacao = 1;
        apiController.request(apiController.endpoints.updateStatusticket, {
            data: {
              id_status_ticket: this.editedItem.id_status_ticket,
              status_ticket: this.editedItem.status_ticket,
              ordem: this.editedItem.ordem,
              screen: this.editedItem.screen || null,
              ids_tipos_conclusao_auto: this.editedItem.ids_tipos_conclusao_auto || [],
            },
            onSuccess: (response) => {
              this.updateTable(response);
              this.loadingStatus = false;
            },
            onError: () => {
              this.loadingStatus = false;
            },
          });
      }
    },
    editItem(item) {
      this.editedIndex = this.statusTickets.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    sortByOrder(items) {
      return (items || []).slice().sort((a, b) => {
        const aOrder = Number(a.ordem) || 0;
        const bOrder = Number(b.ordem) || 0;
        if (aOrder === bOrder) return Number(a.id_status_ticket || 0) - Number(b.id_status_ticket || 0);
        return aOrder - bOrder;
      });
    },
    isFirstItem(item) {
      const index = this.statusTickets.findIndex((s) => Number(s.id_status_ticket) === Number(item.id_status_ticket));
      return index <= 0;
    },
    isLastItem(item) {
      const index = this.statusTickets.findIndex((s) => Number(s.id_status_ticket) === Number(item.id_status_ticket));
      return index === this.statusTickets.length - 1;
    },
    moveUp(item) {
      this.moveItem(item, -1);
    },
    moveDown(item) {
      this.moveItem(item, 1);
    },
    async moveItem(item, direction) {
      if (this.loadingReorder) return;
      const index = this.statusTickets.findIndex((s) => Number(s.id_status_ticket) === Number(item.id_status_ticket));
      if (index < 0) return;
      const targetIndex = index + direction;
      if (targetIndex < 0 || targetIndex >= this.statusTickets.length) return;

      const current = this.statusTickets[index];
      const target = this.statusTickets[targetIndex];
      const currentOldOrder = current.ordem;
      const targetOldOrder = target.ordem;

      this.loadingReorder = true;
      current.ordem = targetOldOrder;
      target.ordem = currentOldOrder;
      this.statusTickets = this.sortByOrder(this.statusTickets);

      try {
        const responses = await Promise.all([
          apiController.request(apiController.endpoints.updateStatusticket, {
            data: {
              id_status_ticket: current.id_status_ticket,
              status_ticket: current.status_ticket,
              ordem: current.ordem,
              screen: current.screen || null,
            },
            silent: true,
          }),
          apiController.request(apiController.endpoints.updateStatusticket, {
            data: {
              id_status_ticket: target.id_status_ticket,
              status_ticket: target.status_ticket,
              ordem: target.ordem,
              screen: target.screen || null,
            },
            silent: true,
          })]);
        const hasError = responses.some((r) => r?.data?.erro);
        if (hasError) throw new Error("Erro ao reordenar status");
        EventBus.$emit("show-alert", {
          mensagem: this.$t("ticketStatus.successes.successUpdate"),
          tipo: "success",
        });
      } catch (e) {
        current.ordem = currentOldOrder;
        target.ordem = targetOldOrder;
        this.statusTickets = this.sortByOrder(this.statusTickets);
        EventBus.$emit("show-error", { error: e });
      } finally {
        this.loadingReorder = false;
      }
    },
    deleteItem(item) {
      if (!item || !item.id_status_ticket) return;
      if (!confirm(this.$t("ticketStatus.confirmDelete"))) return;

      this.loadingStatus = true;
      this.operacao = 2;
      const previousItems = [...this.statusTickets];
      this.statusTickets = this.statusTickets.filter(
        (status) => Number(status.id_status_ticket) !== Number(item.id_status_ticket)
      );
      apiController.request(apiController.endpoints.deleteStatusticket, {
        data: { id_status_ticket: item.id_status_ticket },
        onSuccess: (response) => {
          if (response.data.erro) {
            this.statusTickets = previousItems;
            EventBus.$emit("show-alert", {
              mensagem: this.$t("ticketStatus.errors.errorDelete") + ": " + response.data.mensagem,
              tipo: "error",
            });
          } else {
            EventBus.$emit("show-alert", {
              mensagem: this.$t("ticketStatus.successes.successDelete"),
              tipo: "success",
            });
            this.initialize();
          }
          this.loadingStatus = false;
        },
        onError: () => {
          this.statusTickets = previousItems;
          this.loadingStatus = false;
        },
      });
    },
    close() {
      this.dialog = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
      this.editedIndex = -1;
    },
  },
};
</script>
